import { get } from "lodash";
import { byString } from "../utilities/utils";
import Parser from "../classes/jsonapi_parser";

export const urlsLoading = [];

export default {
    props: {
        options: {
            type: Array,
            default() {
                return [];
            }
        },
        optionsUrl: {
            type: String,
            default: null
        },
        optionsUrlParams: {
            type: Object,
            default() {
                return {};
            }
        },
        vuexPath: {
            type: String,
            default: null
        },
        optionLabelField: {
            type: String,
            default: "name"
        },
        optionValueField: {
            type: String,
            default: "id"
        }
    },

    data() {
        return {
            fieldsToWatch: [],
            vuexStorePath: null,
            vuexGetterPath: null,
            validateHasOptions: true,
        };
    },

    created() {
        if (
            this.findInForm &&
            this.form &&
            this.form.formConfig &&
            (Array.isArray(this.form.formConfig.fields) ||
                typeof this.form.formConfig.fields[Symbol.iterator] ===
                    "function")
        ) {
            this.form.formConfig.fields.forEach(field => {
                if (field.name === this.fieldName) {
                    if (!field.field_extra.options_config && this.validateHasOptions) {
                        window.notify.message(
                            "Invalid field configuration for field: " +
                                field.name,
                            "error"
                        );
                        return;
                    }
                    this.$set(this.fieldConfig, "options", []);
                    this.$set(this.fieldConfig, "optionsUrlParams", {});

                    if (
                        field.field_extra.options_config?.vuex_store_path &&
                        field.field_extra.options_config?.vuex_getter_path
                    ) {
                        window.notify.message(
                            "Can not specify both vuex_store_path and vuex_getter_path in configuration."
                        );
                        return;
                    }

                    if (field.field_extra.options_config?.vuex_store_path) {
                        this.vuexStorePath =
                            field.field_extra.options_config.vuex_store_path;
                    }

                    if (field.field_extra.options_config?.vuex_getter_path) {
                        this.vuexGetterPath =
                            field.field_extra.options_config.vuex_getter_path;
                    }

                    if (field.field_extra.options_config?.optionsURL) {
                        this.setUpOptionsURL(field);
                    }

                    if (field.field_extra.options_config?.optionsUrlParams) {
                        this.$set(
                            this.fieldConfig,
                            "optionsUrlParams",
                            field.field_extra.options_config.optionsUrlParams
                        );
                    }

                    if (field.field_extra.options_config?.options) {
                        this.setUpOptions(field);
                    }

                    this.$set(this.fieldConfig, "optionValueField", "id");
                    this.$set(this.fieldConfig, "optionLabelField", "name");

                    if (field.field_extra.options_config?.optionValueField) {
                        this.fieldConfig.optionValueField =
                            field.field_extra.options_config.optionValueField;
                    }

                    if (field.field_extra.options_config?.optionLabelField) {
                        this.fieldConfig.optionLabelField =
                            field.field_extra.options_config.optionLabelField;
                    }

                    if (field.field_extra.options_config?.default) {
                        this.fieldConfig.default =
                            field.field_extra.options_config.default;
                    }
                }
            });
        } else {
            this.$set(this.fieldConfig, "options", this.options);
            this.$set(
                this.fieldConfig,
                "optionValueField",
                this.optionValueField
            );
            this.$set(
                this.fieldConfig,
                "optionLabelField",
                this.optionLabelField
            );
            this.$set(this.fieldConfig, "optionsURL", this.optionsUrl);
            this.$set(
                this.fieldConfig,
                "optionsUrlParams",
                this.optionsUrlParams
            );
            this.vuexStorePath = this.vuexPath;
            this.vuexGetterPath = this.vuexPath;
        }
    },

    computed: {
        currentOptionsURL() {
            if (this.fieldConfig.optionsURL) {
                var optionsURL = this.fieldConfig.optionsURL;
                this.fieldsToWatch.forEach(match => {
                    let fieldValue = get(this.form.data, match[1], "");
                    if (!fieldValue) {
                        fieldValue = "";
                    }
                    optionsURL = optionsURL.replace(match[0], fieldValue);
                });

                if (!this.paramsAreEmpty(this.fieldConfig.optionsUrlParams)) {
                    let queryString = Object.keys(
                        this.fieldConfig.optionsUrlParams
                    )
                        .map(
                            key =>
                                key +
                                "=" +
                                this.fieldConfig.optionsUrlParams[key]
                        )
                        .join("&");


                    if(optionsURL.includes("?")) {
                        optionsURL += "&";
                    } else {
                        optionsURL += "?";
                    }

                    optionsURL += queryString;
                }

                if(this.useJsonApi && Array.isArray(this.jsonApiIncludes) && this.jsonApiIncludes.length > 0) {
                    if(optionsURL.includes("?")) {
                        optionsURL += "&";
                    } else {
                        optionsURL += "?";
                    }

                    this.jsonApiIncludes.forEach(include => {
                        optionsURL += "include[]=" + include + "&";
                    });
                }

                return optionsURL;
            }
            return "";
        },
        optionValue() {
            if (!this.value && this.value !== 0) {
                return null;
            }

            return this.fieldConfig.options?.find(option => {
                return option[this.fieldConfig.optionValueField] == this.value;
            }) ?? null;
        },
        vuexOptions() {
            if (this.vuexStorePath) {
                return byString(this.$store.state, this.vuexStorePath);
            }

            if (this.vuexGetterPath) {
                return this.$store.getters[this.vuexGetterPath];
            }

            return [];
        }
    },

    watch: {
        currentOptionsURL: function() {
            this.getOptions();
        },
        options: function(newOptions) {
            this.$set(this.fieldConfig, "options", newOptions);

            this.defaultField();
        },
        vuexOptions: function(newOptions) {
            this.$set(this.fieldConfig, "options", newOptions);
            this.defaultField();
        },
    },

    methods: {
        // set up options based on optionsURL param in field config
        setUpOptionsURL(field) {
            this.$set(
                this.fieldConfig,
                "optionsURL",
                field.field_extra.options_config.optionsURL
            );
            var pattern = /:([^:]*):/g,
                match;

            while ((match = pattern.exec(this.fieldConfig.optionsURL))) {
                this.fieldsToWatch.push(match);
            }
        },
        // set up options based on options param in field config
        setUpOptions(field) {
            let options = [];
            field.field_extra.options_config.options.forEach(fieldOption => {
                options.push(fieldOption);
            });

            this.$set(this.fieldConfig, "options", options);
            // legacy event handling for either way this event is triggered
            this.$emit(
                "optionsUpdated",
                JSON.parse(JSON.stringify(options))
            );
            this.$emit(
                'options-updated',
                JSON.parse(JSON.stringify(options))
            );
            this.defaultField();
        },

        async getOptions() {

            if(this.currentOptionsURL.length === 0) {
                return;
            }

            let headers = {
                Accept: "application/json"
            }
            if(this.jsonApi) {
                headers.Accept = "vnd.api+json"
            }

            // add event handling / caching for options loading of the same url
            if(
                window.Bus &&
                window.Bus.$emit
            ) {
                if(urlsLoading.includes(this.currentOptionsURL)) {

                    window.Bus.$on('options-loaded', ({options, optionsUrl}) => {
                        if(optionsUrl !== this.currentOptionsURL) {
                            return;
                        }

                        this.$set(this.fieldConfig, "options", options);
                        // legacy event handling for either way this event is triggered
                        this.$emit(
                            "optionsUpdated",
                            JSON.parse(JSON.stringify(options))
                        );
                        this.$emit(
                            'options-updated',
                            JSON.parse(JSON.stringify(options))
                        );

                        this.defaultField();
                    })
                    return;
                }

                urlsLoading.push(this.currentOptionsURL);
            }

            try {
                const response = await this.apiClient.get(this.currentOptionsURL, {
                    headers
                });

                let options = response.data;
                if (this.jsonApi) {
                    // parse the response and get the array of models
                    options = Parser.parseJSONAPIResponse(
                        response.data
                    ).getModels();
                }

                if(window.Bus && window.Bus.$emit) {
                    window.Bus.$emit('options-loaded', {
                        options,
                        optionsUrl: this.currentOptionsURL
                    });
                    urlsLoading.splice(urlsLoading.indexOf(this.currentOptionsURL), 1);
                }

                this.$set(this.fieldConfig, "options", options);

                // legacy event handling for either way this event is triggered
                this.$emit(
                    "optionsUpdated",
                    JSON.parse(JSON.stringify(options))
                );
                this.$emit(
                    'options-updated',
                    JSON.parse(JSON.stringify(options))
                );
                this.defaultField();

            }catch(err) {
                console.error(err);
                if (
                    window.notify &&
                    typeof window.notify.apiError === "function"
                ) {
                    window.notify.apiError(error);
                }
            }
        },
        defaultField() {
            try {
                var defaultField = false;
                if (!this.optionValue) {
                    defaultField = true;
                } else if (
                    typeof this.optionValue === "object" &&
                    Object.keys(this.optionValue).length === 0
                ) {
                    defaultField = true;
                } else if (this.optionValue === this.fieldConfig.default) {
                    defaultField = true;
                }
                if (defaultField && this.fieldConfig.default) {
                    if (
                        Array.isArray(this.fieldConfig.default) &&
                        this.fieldConfig.default.length > 0
                    ){
                        let options = [];

                        this.fieldConfig.default.forEach(defaultOption => {

                            let matchedOption = this.fieldConfig.options.find(option => {
                                return option[this.fieldConfig.optionLabelField] === defaultOption;
                            });

                            if(matchedOption) {
                                options.push(matchedOption);
                            }});

                        this.updateValue(options);

                    } else {
                        this.fieldConfig.options.forEach(option => {
                            if (
                                option[this.fieldConfig.optionLabelField] ===
                                this.fieldConfig.default
                            ) {
                                this.updateValue(option);
                            }
                        });
                    }
                }
            } catch (error) {
                //console.trace(error);
            }
        },
        paramsAreEmpty(params) {
            for (var key in params) {
                if (Object.prototype.hasOwnProperty.call(params, key))
                    return false;
            }
            return true;
        }
    }
};
